import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../service/api_service';
import { ColumnApi, ColumnGroup, GridApi } from 'ag-grid-community';
import { Subscription } from 'rxjs';
import { lateworkingModel } from '../../model'
import { Router } from '@angular/router'
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import * as $ from 'jquery';

@Component({
    selector: 'app-lateworkingreport',
    template: require('./lateworkingreport.component.html'),
    styles: []
})
export class LateWorkingReportComponent implements OnInit {

    expDetails: any;
    private columnDefs;
    private rowData;
    private rowHeight;
    api: GridApi;
    busy: Subscription;
    columnApi: ColumnApi;
    defaultColDefine;
    private gridColumnApi;
    private detailCellRendererParams;
    currentMonth: any;
    firstDate: string;
    lastDate: string;
    currentDate: any;
    token:any;
    lateworkingModel: lateworkingModel = new lateworkingModel();

    LateWorking_Form = new FormGroup({
        fromDate: new FormControl('', [Validators.required]),
        toDate: new FormControl('', [Validators.required]),

    });

    static parameters = [ApiService, Router, HttpClient]

    constructor(
        private apiService: ApiService, private router: Router, private http: HttpClient

    ) {
        this.columnDefs = [
            { headerName: 'S.No.', field: 'sno', valueGetter: "node.rowIndex + 1", width: 90 },
            { headerName: 'Employee Name', field: "Client_Name", width: 350 },
            { headerName: 'Manager', field: "Manager", width: 250 },
            { headerName: 'Designation', field: "Designation", width: 250 },
            //   { headerName: 'Head Qtr', field: "HQName" },
            { headerName: 'DCR Date', field: "PlanDate", width: 250 },
            { headerName: 'Day Plan Time', field: "DayPlanTime", width: 250 },
        ];
        this.defaultColDefine = { resizable: true };

        this.rowHeight = 50;
    }

    ngOnInit() {
        this.token = JSON.parse(sessionStorage.getItem("currentUser"));
        $('#filter-option').trigger('click');
        var date = new Date();
        var year = date.getFullYear();
        var month = (date.getMonth() + 1).toString().padStart(2, "0");
        this.firstDate = year + '-' + month + '-' + date.getDate().toString().padStart(2, "0");
        this.lastDate = year + '-' + month + '-' + date.getDate().toString().padStart(2, "0");
        console.log('firstDate ', this.firstDate, this.lastDate);
        this.LateWorking_Form.controls['fromDate'].setValue(
            this.firstDate
        );
        this.LateWorking_Form.controls['toDate'].setValue(
            this.lastDate
        );
    }

    onGridReady = (params) => {
        this.api = params.api;
        this.gridColumnApi = params.columnApi;
        this.api.hideOverlay();
    }

    onBtnExport() {
        this.api.exportDataAsExcel({ fileName: 'LateWorking_Report' });
    }

    onFilterTextBoxChanged() {
        this.api.setQuickFilter(document.querySelector<HTMLInputElement>('#filter-text-box')!.value);
        this.api.refreshCells();
    }


    LateWorkingReport() {
        
        this.lateworkingModel.fromDate = this.LateWorking_Form.value.fromDate;
        this.lateworkingModel.toDate = this.LateWorking_Form.value.toDate;
        this.lateworkingModel.empId = this.token.clientId;
        this.lateworkingModel.LoginId=this.token.id;
        console.log(this.lateworkingModel);
        this.busy = this.apiService.LateWorkingReport(this.lateworkingModel).subscribe((res: any) => {
            this.rowData = res;
        })
    }

}
